// Registro del service worker de la app instalable (public/service-worker.js).
// Solo en producción: en desarrollo interferiría con el recargado en caliente.

export const registerServiceWorker = () => {
    if (process.env.NODE_ENV !== 'production') return;
    if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;

    window.addEventListener('load', () => {
        navigator.serviceWorker
            .register(`${process.env.PUBLIC_URL}/service-worker.js`)
            .catch((error) => console.error('No se pudo registrar el service worker:', error));
    });
};
